import { lazy } from "react";

const Admin = lazy(() => import("features/Admin/v2"));
const UserDetail = lazy(() => import("features/Admin/v2/Users/Detail"));
const OrderGroupDetail = lazy(() => import("features/Admin/v2/Orders/Detail"));
const StrategyDetail = lazy(() =>
  import("features/Admin/v2/Strategies/Detail")
);

export const ADMIN_PATH = "/admin";
// The Tabs component reads `activeTab` from the query string.
export const ADMIN_USERS_PATH = `${ADMIN_PATH}?activeTab=users`;
export const ADMIN_USER_DETAIL_PATH = `${ADMIN_PATH}/users/:userId`;
export const ADMIN_STRATEGIES_PATH = `${ADMIN_PATH}?activeTab=strategies`;
export const ADMIN_STRATEGY_DETAIL_PATH = `${ADMIN_PATH}/strategies/:strategyId`;
export const ADMIN_ORDERS_PATH = `${ADMIN_PATH}?activeTab=orders`;
export const ADMIN_ORDER_DETAIL_PATH = `${ADMIN_PATH}/orders/:groupId`;

export const adminUserDetailPath = (userId) => `${ADMIN_PATH}/users/${userId}`;

export const adminOrderDetailPath = (groupId) =>
  `${ADMIN_PATH}/orders/${groupId}`;

export const adminStrategyDetailPath = (strategyId) =>
  `${ADMIN_PATH}/strategies/${strategyId}`;

export const adminRoutes = [
  {
    path: ADMIN_PATH,
    component: <Admin />,
  },
  {
    path: ADMIN_USER_DETAIL_PATH,
    component: <UserDetail />,
  },
  {
    path: ADMIN_ORDER_DETAIL_PATH,
    component: <OrderGroupDetail />,
  },
  {
    path: ADMIN_STRATEGY_DETAIL_PATH,
    component: <StrategyDetail />,
  },
];
